



















































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "../utils/event";

import Edit from "@/components/PrjStorage/Edit.vue";
import StorageInfo from "@/components/PrjStorage/StorageInfo.vue";

const PrjStorageHeaders: Header[] = [
  { title: "名称", key: "name" },
  { title: "容量", key: "capacity" },
  { title: "挂载", key: "mountStatus" },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "操作", key: "", width: 80 }
];
export default Vue.extend({
  name: "PrjStorage",
  components: { TableLayout, Edit, StorageInfo },
  props: { projectId: { type: String } },
  data() {
    return {
      PrjStorageHeaders,
      showTools: true,
      disabled: false
    };
  },
  computed: {
    ...mapState("PrjStorage/Storage", [
      "pageNum",
      "total",
      "hasNext",
      "pageSize",
      "loading"
    ]),
    ...mapGetters("PrjStorage/Storage", ["tableData"])
  },
  mounted() {
    this.getStorage();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjStorage/Storage", [
      "getData",
      "delete",
      "pageTurn",
      "clear",
      "filterSearch"
    ]),
    getStorage() {
      this.getData({ url: `/storage/pvc/${this.projectId}` });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.metadata.name);
          break;
      }
    },
    create(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({
          url: `/storage/pvc/${this.projectId}?name=${name}`,
          getDataUrl: `/storage/pvc/${this.projectId}`
        }).then(() => {
          this.$message.success("删除成功");
        });
      });
    },
    showStorageInfo(name: any) {
      this.showTools = false;
      eventBus.$emit("setBeard", {
        name: "详情",
        callback: () => {
          this.showTools = true;
          (this.$refs.storageInfo as any).close();
        }
      });
      (this.$refs.storageInfo as any)?.show(name);
    }
  }
});
